import React from "react"
import { Box, Button, Typography } from "@mui/material";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material"

const IncrementalButtons = ({
    // value,
    // title,
    option,
    onIncrement,
    onDecrement,
}) => (
    <Box sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    }}>
        <Button disabled={option.value === option.min_pax} onClick={() => onDecrement(option.title)}>
            <RemoveCircleOutline
                color={option.value > option.min_pax ? "primary" : "grayText"}
            />
        </Button>
        <Typography>
            {option.value}
        </Typography>
        <Button color="primary" onClick={() => onIncrement(option.title)}>
            <AddCircleOutline color="primary" />
        </Button>
    </Box>
)

export default IncrementalButtons;
